*,
::after,
::before {
  box-sizing: border-box;
}

.height-measuring {
  display: flex;
  width: 0;
  height: 100%;
  visibility: hidden;
}

.line-clamp {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: var(--max-lines);
  overflow: hidden;
}

.line-measuring {
  visibility: hidden;
  position: absolute;
}

:host {
  display: flex;
  align-items: flex-start;
  justify-items: flex-start;
  align-self: stretch;
  position: relative;
  width: 100%;
  text-align: start;
}

.content {
  background-color: unset;
  border: none;
  color: inherit;
  font: inherit;
  margin: 0;
  padding: 0;
  outline: 0;
  position: absolute;
  inset-inline: 0;
  padding-inline: inherit;
}